import { fromJS } from 'immutable';
import { transformAllKindsOfRates } from '../../../utils/mass-rate-change-helpers';

/*
 products: [
 {
   productId,
   productName,
   offers: [],
   extras: [],
   seasonRates: [],
 }
]
 */
const initialState = fromJS({
  locationName: 'Airlie Beach Luxury Island Suites',
  updateType: '', // enum: ['extras', 'offers', 'seasonRates']
  rateType: '', // enum: ['nett', 'commission', 'discount']
  seasonRates: {
    nettMeasure: 'dollar',
    commissionMeasure: 'dollar',
    discountMeasure: 'dollar',
    roundingSetting: {
      cents: 50,
      roundType: 'normal', // enum: ['normal', 'alwaysUp', 'alwaysDown']
    },
    retailDiffForAll: '',
    nettDiffForAll: '',
    discountDiffForAll: '',
    commissionForAll: '',
    notApplyToExtraChildForcommission: false,
    notApplyToExtraChildFornett: false,
    products: [],
    subMenus: [],
  },
  offers: {
    nettMeasure: 'dollar',
    commissionMeasure: 'dollar',
    discountMeasure: 'dollar',
    roundingSetting: {
      cents: 50,
      roundType: 'normal', // enum: ['normal', 'alwaysUp', 'alwaysDown']
    },
    retailDiffForAll: '',
    nettDiffForAll: '',
    discountDiffForAll: '',
    commissionForAll: '',
    notApplyToExtraChildForcommission: false,
    notApplyToExtraChildFornett: false,
    products: [],
    subMenus: [],
  },
  extras: {
    nettMeasure: 'dollar',
    commissionMeasure: 'dollar',
    discountMeasure: 'dollar',
    roundingSetting: {
      cents: 50,
      roundType: 'normal', // enum: ['normal', 'alwaysUp', 'alwaysDown']
    },
    retailDiffForAll: '',
    nettDiffForAll: '',
    discountDiffForAll: '',
    commissionForAll: '',
    notApplyToExtraChildForcommission: false,
    notApplyToExtraChildFornett: false,
    products: [],
    subMenus: [],
  },
  gettingData: true,
  saving: false,
  updated: [], // enum: ['extras', 'offers', 'seasonRates']
  popOverOpen: false,
  popOverAnchorEl: {},
});


export default function massRateChangeReducer(state = initialState, { type, payload }) {
  const updateType = state.get('updateType');
  const rateType = state.get('rateType');
  const notApplyToExtraChild = state.getIn([updateType, `notApplyToExtraChildFor${rateType}`]);

  switch (type) {
    case 'UPDATE_MASS_RATE_CHANGE_CALCULATION':
      return payload;
    case 'ON_CHANGE_NOT_APPLY_MASS_RATE_CHANGE_TO_EXTRA_CHILD':
      return state.setIn([updateType, `notApplyToExtraChildFor${rateType}`], !notApplyToExtraChild);
    case 'CHANGE_WIDGET_VALUE_FOR_APPLY_ALL':
      return state.setIn([updateType, payload.key], payload.value)
        .updateIn([updateType, 'products'], products => products.map(product => {
          return product.set(payload.key.slice(0, -6), payload.value);
        }));
    case 'CHANGE_WIDGET_VALUE_FOR_PRODUCT':
      return state.updateIn([updateType, 'products'], products => products.map((product, index) => {
        if (index !== payload.ratePackageIndex) return product;
        return product.set(payload.key, payload.value);
      }));
    case 'CHANGE_MASS_RATE_CHANGE_MEASURE':
      return state.setIn([updateType, `${rateType}Measure`], payload.retailNettMeasure);
    case 'CHANGE_MASS_RATE_CHANGE_RATE_TYPE':
      return state.merge(fromJS({
        rateType: payload.rateType,
        updateType: payload.updateType,
      }));
    case 'CHANGE_MASS_RATE_CHANGE_UPDATE_TYPE':
      return state.merge(fromJS({
        updateType: payload.updateType,
        locationName: payload.locationName,
        rateType: state.getIn([payload.updateType, 'subMenus', 0]),
      }));
    case 'GETTING_MASS_RATE_CHANGE_DATA':
      return state.merge({ saving: true, gettingData: true });
    case 'GOT_MASS_RATE_CHANGE_DATA':
      const allRatesTransformed = transformAllKindsOfRates(payload.allKindsOfRates);
      return state.merge(fromJS(allRatesTransformed))
        .set('locationId', payload.locationId)
        .set('gettingData', false).set('saving', false);
    case 'SAVING_MASS_RATE_CHANGE_DATA':
      return state.set('saving', true);
    case 'SAVED_MASS_RATE_CHANGE_DATA':
      return state.merge(transformAllKindsOfRates(payload.allKindsOfRates))
        .set('saving', false)
        .update('updated', updated => updated.concat(fromJS(payload.allUpdated)));
    case 'SHOW_CONTRACTING_ERROR_STRING':
      return state.merge(fromJS({ gettingData: false, saving: false }));
    case 'CLOSE_POPOVER_IN_MASS_RATE_CHANGE':
      return state.set('popOverOpen', false);
    case 'OPEN_POPOVER_WHEN_LEAVING_MASS_RATE_CHANGE':
      return state.set('popOverOpen', true)
        .set('popOverAnchorEl', payload.popOverAnchorEl);
    case 'CHANGE_ROUNDING_SETTINGS_IN_MASS_RATE_CHANGE':
      return state.updateIn([state.get('updateType'), 'roundingSetting'], settings => settings
        ? settings.merge(fromJS(payload))
        : fromJS(payload)
      );
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/mass-rate-change/mass-rate-change-reducer.js